import { createActionGroup } from '@ngrx/store';

export const UserSocieteProfilActions = createActionGroup({
  source: 'User Societe Profil',
  events: {}
});
